<template>
  <thead class="dark:bg-ontick-steel-500 bg-gray-300">
    <tr class="text-left">
      <th>
        <span class="sr-only"> Ligar/desligar investimento </span>
      </th>
      <th>
        <span> Estratégia </span>
      </th>
      <th>
        <span> Entrada </span>
      </th>
      <th>
        <span> Saída </span>
      </th>
      <th>
        <span> Resultado </span>
      </th>
      <th>
        <span> Detalhes </span>
      </th>
    </tr>
  </thead>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
th {
  @apply px-3 py-2  text-sm font-bold;
}
</style>
